import angular from 'angular';

angular
  .module('cxSettings')
  .controller('AddTaskParameterDefinitionDialogCtrl', [
    '$http',
    'appUrls',
    'flySvc',
    'resourceFactorySvc',
    'close',
    'taskTemplateId',
    '$element',
    '$filter',
    addTaskParameterDefinitionDialogCtrl,
  ]);

function addTaskParameterDefinitionDialogCtrl(
  $http,
  appUrls,
  flySvc,
  resourceFactorySvc,
  close,
  taskTemplateId,
  $element,
  $filter,
) {
  var vm = this;
  vm.parameterDefinition = {
    taskTemplateId: taskTemplateId,
    parameterValueType: 0, // Default to text
    systemParameterType: null,
    computedParameterType: null,
  };
  vm.showValidation = false;
  vm.selectionItems = [];

  // Copied from C# code to have labeled enum constants
  let systemParameterValueTypes = { text: 0, numeric: 1, date: 2, boolean: 3, selectionList: 4 };
  let systemParameterType = {
    vatBalanceAmount: 3,
    vatDecemberAdvanceAmount: 4,
    vatAdvanceOneAmount: 5,
    vatAdvanceTwoAmount: 6,
    fgovIntracomAmount: 7,
    submissionConfirmationNumber: 9,
    taxableIncome: 10,
    payableWithholdingTax: 11,
    nihilCustomerListingOnVatDeclaration: 12,
    noIntraCommunityVatDeclared: 13,
    nbbAnnualAccountFilingDate: 14,
    nbbAnnualAccountAmount: 15,
    pitCalculationAmount: 16,
    pitIsAmountToReceive: 17,
    structuredRemittanceInformation: 18,
    ibanNumberDestinationAccount: 19,
    vatRefundRequested: 20,
    vatAccountCurrentBalance: 21,
  };

  // Copied from Packages => SystemParameterValueTypeMapping
  let mapSystemParameterType = systemParameter => {
    switch (systemParameter) {
      case systemParameterType.nihilCustomerListingOnVatDeclaration:
      case systemParameterType.noIntraCommunityVatDeclared:
      case systemParameterType.pitIsAmountToReceive:
      case systemParameterType.vatRefundRequested:
        return systemParameterValueTypes.boolean;
      case systemParameterType.nbbAnnualAccountFilingDate:
        return systemParameterValueTypes.date;
      case systemParameterType.ibanNumberDestinationAccount:
      case systemParameterType.structuredRemittanceInformation:
      case systemParameterType.submissionConfirmationNumber:
        return systemParameterValueTypes.text;
      default:
        return systemParameterValueTypes.numeric;
    }
  };

  let computedParameterType = {
    vatAmount: 1,
    vatAdvanceAmountOne: 2,
    vatAdvanceAmountTwo: 3,
    vatFlagToPay: 4,
    vatFlagToBeRefunded: 5,
    vatFlagTransferredToNextPeriod: 6,
  };

  // Copied from Packages => SystemParameterValueTypeMapping
  let mapComputedParameterType = computedParameter => {
    switch (computedParameter) {
      case computedParameterType.vatAmount:
      case computedParameterType.vatAdvanceAmountOne:
      case computedParameterType.vatAdvanceAmountTwo:
        return systemParameterValueTypes.numeric;
      case computedParameterType.vatFlagToPay:
      case computedParameterType.vatFlagToBeRefunded:
      case computedParameterType.vatFlagTransferredToNextPeriod:
        return systemParameterValueTypes.boolean;
      default:
        return systemParameterValueTypes.numeric;
    }
  };

  vm.systemParameterTypeChanged = function(value) {
    vm.parameterDefinition.computedParameterType = undefined;
    if (vm.parameterDefinition.systemParameterType > 0) {
      vm.parameterDefinition.parameterValueType = mapSystemParameterType(
        vm.parameterDefinition.systemParameterType,
      );
    }
  };

  vm.computedParameterTypeChanged = function(value) {
    vm.parameterDefinition.systemParameterType = undefined;
    if (vm.parameterDefinition.computedParameterType > 0) {
      vm.parameterDefinition.parameterValueType = mapComputedParameterType(
        vm.parameterDefinition.computedParameterType,
      );
    }
  };

  vm.addSelectionItem = () => {
    vm.selectionItems.push('');
  };
  vm.onSelectionItemChanged = index => {
    vm.selectionItems[index] = vm.selectionItems[index].replace(';', '');
  };

  vm.save = function() {
    if (vm.parameterDefinition.parameterValueType === 4 && !vm.selectionItems.length) return;
    if (vm.parameterDefinition.parameterValueType === 4) {
      vm.parameterDefinition = {
        ...vm.parameterDefinition,
        selectionItems: vm.selectionItems.join(';'),
      };
    }

    vm.saving = true;
    $http.post(`${appUrls.tasks}/api/TaskParameters/CreateDefinition`, vm.parameterDefinition).then(
      function({ data }) {
        vm.saving = false;
        $element.modal('hide');
        close(data, 500);
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error);
        return '';
      },
    );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
